module.exports = __webpack_public_path__ + "img/06.66015a10.png";